(function ($) {
    'use strict';
    $(document).ready(function () {
        var accessibility = new window.Accessibility();
    });
    window.Accessibility = jQuery.klass({
        init: function () {
            // Accessibility
            this.tabbedControlsSelector = this.playerSelector + ', .tabbed-control, .jw-settings-content-item, .jw-button-color, .jw-logo';
            this.handleCustomAccessibility();
        },
        handleCustomAccessibility: function () {
            var context = this;
            $(document).on('keyup', function (e) {
                var keycode = (e.keyCode ? e.keyCode : e.which);
                // Tab or Escape key pressed
                if (keycode === 9 || keycode === 27) {
                    context.setFocusOnActiveElement($(document.activeElement));
                }
                // Enter key pressed
                if (keycode === 13) {
                    var activeElement = $(document.activeElement);
                    if (context.isActiveElementEnterChangeFocusControl(activeElement)) {
                        context.setFocusOnActiveElement(activeElement);
                    }
                }
            });

            // Required in order to handle fullscreen exit using 'Esc' key
            if (document.addEventListener) {
                document.addEventListener('webkitfullscreenchange', function () { context.setFocusOnActiveElement($(document.activeElement)) }, false);
                document.addEventListener('mozfullscreenchange', function () { context.setFocusOnActiveElement($(document.activeElement)) }, false);
                document.addEventListener('fullscreenchange', function () { context.setFocusOnActiveElement($(document.activeElement)) }, false);
                document.addEventListener('MSFullscreenChange', function () { context.setFocusOnActiveElement($(document.activeElement)) }, false);
            }

            $(this.tabbedControlsSelector).on('blur', function () {
                if (context.isActiveElementTabbedControl($(document.activeElement)))
                    return;

                // If active element is outside plugin remove outline
                $(context.tabbedControlsSelector).removeClass('focus-outline');
            });
        },
        setFocusOnActiveElement: function (activeElement) {
            $(this.tabbedControlsSelector).removeClass('focus-outline');
            if (this.isActiveElementTabbedControl(activeElement)) {
                activeElement.addClass('focus-outline');
            }
        },
        isActiveElementTabbedControl: function (activeElement) {
            return activeElement.hasClass('tabbed-control') ||
                activeElement.hasClass('jwplayer') ||
                activeElement.hasClass('jw-settings-content-item') ||
                activeElement.hasClass('jw-button-color') ||
                activeElement.hasClass('jw-logo');
        },
        isActiveElementEnterChangeFocusControl: function (activeElement) {
            return activeElement.hasClass('jw-settings-playbackRates') ||
                activeElement.hasClass('jw-icon-settings') ||
                activeElement.hasClass('jw-settings-quality') ||
                activeElement.hasClass('jw-settings-content-item');
        }
    });

})(jQuery);